import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_SETTINGS_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  ROLES_AND_PERMISSIONS_ROUTE_NAME,
  ROLES_PERMISSIONS,
  TRANSLATION_GROUP_ROLES_AND_PERMISSIONS,
} from './constants';
import { getTranslationKeys } from './translations';

export class RolesAndPermissionsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ROLES_AND_PERMISSIONS_ROUTE_NAME,
      path: 'permissions-manager',
      component: () => import('./pages/RolesAndPermissionsPage/RolesAndPermissionsPage.vue'),
      permission: ROLES_PERMISSIONS.ROLES_CREATE,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_SETTINGS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_PERMISSIONS_MANAGER'),
      to: {
        name: ROLES_AND_PERMISSIONS_ROUTE_NAME,
      },
      permission: ROLES_PERMISSIONS.ROLES_CREATE,
      id: ROLES_AND_PERMISSIONS_ROUTE_NAME,
      order: 21,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_ROLES_AND_PERMISSIONS, getTranslationKeys);
  }
}
